<section class="c-section--static" *ngIf="!vm.isAuthenticated">
	<div class="c-section__header c-text--center">
		<div [class]="vm.headerClass">
			<div class="o-container">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="vm.product === 'SIFFI'">
						<a id="headerLogoSiffi" href="javascript:void(0);" (click)="vm.navigateToRoot($event)" class="auth-public__header-logo auth-public__header-logo--siffi c-header__logo c-logo c-logo--siffi-green c-logo--siffi-green@up-to-md"></a>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="vm.product === 'MINUDOC'">
						<a id="headerLogoMinudoc" href="javascript:void(0);" (click)="vm.navigateToRoot($event)" class="auth-public__header-logo auth-public__header-logo--minudoc c-header__logo c-logo c-logo--{{ vm.logoSuffix }}"></a>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="vm.product === 'PREVISIT'">
						<a id="headerLogoPrevisit" href="javascript:void(0);" (click)="vm.navigateToRoot($event)" class="auth-public__header-logo auth-public__header-logo--previsit c-header__logo c-logo c-logo--previsit c-logo--previsit@up-to-md"></a>
					</div>
				</div>
			</div>
			<nav class="c-nav c-nav--tab-bar auth-public__lang-nav">
				<div class="o-container">
					<div class="c-nav__menu">
						<ul class="c-nav__list">
							<li class="c-nav__item" *ngIf="vm.product === 'SIFFI'">
								<siffi-language-picker [currentLocale]="vm.locale" (localeSelected)="vm.setLocale($event)"></siffi-language-picker>
							</li>
							<li class="c-nav__item c-nav__dd" [ngClass]="{ 'c-nav__dd--open': vm.isLanguageMenuOpen }" *ngIf="vm.product !== 'SIFFI'">
								<a id="selectedLangMenu" class="c-nav__link c-nav__dd-toggle c-nav__dd-toggle--arrow" (click)="vm.toggleLangMenu()">
									<i class="c-flag c-flag--{{ vm.getLocaleOption(vm.locale).icon }} c-nav__thumb" aria-hidden="true"></i>
									<span id="selectedLangValue" class="c-nav__label c-text c-text--uppercase">{{ vm.getLocaleOption(vm.locale).shortLabel }}</span>
								</a>
								<div class="c-nav__dd-menu">
									<ul class="c-nav__dd-list">
										<ng-container *ngFor="let language of vm.locales; let $index = index">
											<li class="c-nav__dd-item" *ngIf="language.locale !== vm.locale" (click)="vm.setLocale(language.locale)">
												<a id="selectLang{{$index}}" href="javascript:void(0)" class="c-nav__dd-link">
													<i class="c-flag c-flag--{{ language.icon }} c-nav__dd-icon c-nav__thumb" aria-hidden="true"></i>
													<span id="selectLangValue{{$index}}" class="c-text c-text--uppercase">{{ language.shortLabel }}</span>
												</a>
											</li>
										</ng-container>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	</div>

	<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--flex o-grid__cell--center@md-and-up u-no-p o-grid__cell--o2@up-to-md">
		<main class="o-container c-container">
			<div class="o-grid o-grid--center-h">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-40@xl-and-up">
					<div class="c-content">
						<h1 class="c-text--bold c-text--center">{{ "Login.Login_Title" | translateUnauthenticated }}</h1>
						<form class="c-form" id="login-form" #mainForm="ngForm" name="vm.form" style="margin-top: 15px" [hidden]="vm.isVerificationProcess">
							<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || email.dirty || email.touched) && email.invalid }">
								<label for="{{ 'email-' }}" class="c-form__label">{{ 'Login.Email' | translateUnauthenticated }}</label>
								<input id="{{ 'email-' }}" name="email" #email="ngModel" placeholder="{{ 'Login.Email' | translateUnauthenticated}}" type="email" class="c-form__input c-form__input--sm" [(ngModel)]="vm.email" maxlength="255" pattern='^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$' required>
								<item-form-error-with-translator *ngIf="(vm.submitted || email.dirty || email.touched) && email.invalid" [fieldName]="'Login.Email' | translateUnauthenticated" [error]="email.errors"></item-form-error-with-translator>
							</div>
							<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': vm.submitted && password.invalid }">
								<label for="{{ 'password-' }}" class="c-form__label">{{ 'Login.Password' | translateUnauthenticated }}</label>
								<input id="{{ 'password-' }}" (keyup)="$event.keyCode === 13 && vm.login(mainForm)" name="password" type="password" #password="ngModel" placeholder="{{ 'Login.Password' | translateUnauthenticated}}" class="c-form__input c-form__input--sm" [(ngModel)]="vm.password" required>
								<item-form-error-with-translator *ngIf="vm.submitted && password.invalid" [fieldName]="'Login.Password' | translateUnauthenticated" [error]="password.errors"></item-form-error-with-translator>
							</div>
							<p class="c-text c-text--s3 c-text--center u-osb-lg" id="st-error" *ngIf="vm.showError && !vm.originError">{{ "Login.Incorrect_Username_Or_Password" | translateUnauthenticated }}</p>
							<p class="c-text c-text--s3 c-text--center u-osb-lg" id="st-error" *ngIf="vm.originError">{{ vm.originError }}</p>
							<div class="c-form__group">
								<button id="login-submit-button" (click)="vm.login(mainForm)" type="button" class="c-button c-button--s1 c-form__center-button">{{ "Login.Login_Button" | translateUnauthenticated }}</button>
							</div>
							<div class="o-grid">
								<div class="o-grid__cell o-grid__cell--center-h">
									<div class="c-content">
										<a id="forgot-password-link" [routerLink]="['/reset-password']" [queryParams]="vm.localeParams" class="c-button--link">{{ "Login.Forgot_Password" | translateUnauthenticated }}</a>
									</div>
									<a id="register-link" [routerLink]="['/register']" [queryParams]="vm.localeParams" class="c-button--link">{{ "Login.Register_Link" | translateUnauthenticated }}</a>
								</div>
							</div>
						</form>
						<div class="c-form__group" *ngIf="vm.isVerificationProcess" style="margin-top: 15px" [ngClass]="{ 'c-form__group--error': vm.submitted && verificationCode.invalid }">
							<label class="c-form__label" *ngIf="!vm.isTotpVerification">{{ 'Login.Verification_Code' | translateUnauthenticated }}</label>
							<label class="c-form__label" *ngIf="vm.isTotpVerification">{{ 'Login.Verification_Code_Totp' | translateUnauthenticated }}</label>
							<input name="verificationCode" type="text" #verificationCode="ngModel" class="c-form__input c-form__input--sm" [(ngModel)]="vm.verificationCode" maxlength="6" required>
							<item-form-error-with-translator *ngIf="vm.submitted && verificationCode.invalid" [fieldName]="'Login.Verification_Code' | translateUnauthenticated" [error]="verificationCode.errors"></item-form-error-with-translator>
							<div class="c-text c-text--center c-text--sm u-ost-sm">
								{{ ('Login.Generate_New_Verification_Code' | translateUnauthenticated) }}
							</div>
							<p class="c-text c-text--s3 c-text--center u-osb-lg" id="st-error-wrong-verification-code" style="margin-top: 10px" *ngIf="vm.showWrongVerificationError">{{ "Login.Wrong_Verification_Code" | translateUnauthenticated }}</p>
							<button style="margin-top: 14px"
								id="submitVerificationCode"
								(click)="vm.login(mainForm)"
								type="button"
								class="c-button c-button--s1 c-form__center-button">
								OK
							</button>
						</div>
					</div>
				</div>
			</div>
			<loader-overlay *ngIf="vm.loading"></loader-overlay>
		</main>
	</div>
</section>
